function Search() {
  return (
    <svg
      data-testid="search-icon"
      width={19}
      height={20}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 39 40"
    >
      <path
        d="M38.323 37.623L28.6 27.546a.879.879 0 00-.641-.274h-.776c2.585-2.898 4.167-6.765 4.167-11.023C31.351 7.273 24.335 0 15.676 0 7.016 0 0 7.273 0 16.25c0 8.975 7.016 16.248 15.676 16.248 4.107 0 7.838-1.64 10.634-4.312v.797c0 .25.098.484.263.664l9.722 10.078a.883.883 0 001.282 0l.746-.774a.963.963 0 000-1.328zM15.676 30c-7.333 0-13.264-6.149-13.264-13.75S8.342 2.5 15.676 2.5c7.333 0 13.264 6.149 13.264 13.75S23.009 30 15.676 30z"
        fill="#2C2C2C"
      />
    </svg>
  );
}

export default Search;
